import {List} from 'immutable';

function simpleValidator(attr, error) {
  const attribute = attr || '';
  if (attribute.length === 0) {
    return List([error]);
  }

  return null;
}

export const districtModelValidators = {
  getName() {
    return simpleValidator(this.getName(), 'You must enter a district name.');
  },

  getState() {
    return simpleValidator(this.getState(), 'You must select a state.');
  },

  getCounty() {
    return simpleValidator(this.getCounty(), 'You must provide a county.');
  },

  getNcesLocale() {
    return simpleValidator(this.getNcesLocale(), 'You must select an NCES Locale.');
  }
};
